import { patchInitialVisitInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitInformation/patchInitialVisitInformationQueryFunction';
import { patchVisitInformationParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitInformation/patchVisitInformationQuery.type';
import { patchVisitInformation } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitInformation/patchVisitInformationQueryFunction';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const usePatchVisitInformationMutation = () => {
  return useMutation<AxiosResponse, Error, patchVisitInformationParams>({
    mutationFn: (params: patchVisitInformationParams) => {
      if (params && params?.type === 'initial') {
        return patchInitialVisitInformationFunction(params);
      }
      return patchVisitInformation(params);
    },
  });
};
